import { render, staticRenderFns } from "./CustomerResultList.vue?vue&type=template&id=36ee07b7&scoped=true"
import script from "./CustomerResultList.vue?vue&type=script&lang=js"
export * from "./CustomerResultList.vue?vue&type=script&lang=js"
import style0 from "./CustomerResultList.vue?vue&type=style&index=0&id=36ee07b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ee07b7",
  null
  
)

export default component.exports